import { render, staticRenderFns } from "./SafeDutyCard.vue?vue&type=template&id=4932378f&scoped=true"
import script from "./SafeDutyCard.vue?vue&type=script&lang=js"
export * from "./SafeDutyCard.vue?vue&type=script&lang=js"
import style0 from "./SafeDutyCard.vue?vue&type=style&index=0&id=4932378f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4932378f",
  null
  
)

export default component.exports